// extracted by mini-css-extract-plugin
export default {"wrapper":"fourPlayersIntroduction_wrapper__QTamL","button":"fourPlayersIntroduction_button__kUC4p"};